import styled from 'styled-components';

export const StyledNotificationContainer = styled.div`
  margin-bottom: 20px;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: flex-end;
`;

export const StyledStepDescription = styled.div`
  margin-bottom: 24px;
`;
